import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

type BlockingStatusOverlayProps = {
  open: boolean;
  icon?: ReactNode;
  title: string;
  description?: string;
};

export default function BlockingStatusOverlay({
  open,
  icon,
  title,
  description,
}: BlockingStatusOverlayProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-3xl border border-white/60 bg-white/95 p-6 shadow-[0_24px_80px_-24px_rgba(15,23,42,0.45)]">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-50 text-rose-600">
          {icon ?? <Loader2 className="h-7 w-7 animate-spin" />}
        </div>
        <div className="mt-4 text-center">
          <h2 className="text-base font-semibold text-slate-900">{title}</h2>
          {description && (
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}
